import { styled } from "@mui/styles";
import { Dialog } from "@mui/material";

const blumiraBlue = "#007ffc";

const PREFIX = "LoginViewStyles";
export const rootClasses = {
  root: `${PREFIX}-root`,
  loginCard: `${PREFIX}-loginCard`,
  logo: `${PREFIX}-logo`,
  alert: `${PREFIX}-alert`,
  loadingContainer: `${PREFIX}-loadingContainer`,
  loadingText: `${PREFIX}-loadingText`,
  circularProgress: `${PREFIX}-circularProgress`,
  textContainer: `${PREFIX}-textContainer`,
  buttonContainer: `${PREFIX}-buttonContainer`,
  primaryButton: `${PREFIX}-primaryButton`,
};

export const dialogClasses = {
  logo: `${PREFIX}-logo`,
  dialogContent: `${PREFIX}-dialogContent`,
  dialogTitle: `${PREFIX}-dialogTitle`,
  dialogDescText: `${PREFIX}-dialogDescText`,
  auth0InspiredTextField: `${PREFIX}-auth0InspiredTextField`,
  auth0ButtonContainer: `${PREFIX}-auth0ButtonContainer`,
  auth0InspiredFilledButton: `${PREFIX}-auth0InspiredFilledButton`,
  auth0InspiredTextButton: `${PREFIX}-auth0InspiredTextButton`,
  formHelperText: `${PREFIX}-formHelperText`,
};

export const Root = styled("div")(({ theme }) => ({
  [`&.${rootClasses.root}`]: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "center",
    backgroundColor: "#F4F6F8",
  },
  [`& .${rootClasses.loginCard}`]: {
    padding: 30,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    "& h2": {
      fontWeight: "normal",
    },
    "& p": {
      fontSize: 13,
    },
  },
  [`& .${rootClasses.logo}`]: {
    height: 50,
    marginBottom: 30,
  },
  [`& .${rootClasses.alert}`]: {
    width: 300,
    display: "flex",
    marginBottom: 15,
    alignItems: "center",
  },
  [`& .${rootClasses.loadingContainer}`]: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
  },
  [`& .${rootClasses.loadingText}`]: {
    fontSize: 20,
  },
  [`& .${rootClasses.circularProgress}`]: {
    color: blumiraBlue,
  },
  [`& .${rootClasses.textContainer}`]: {
    maxWidth: 650,
    padding: "30px 0",
    textAlign: "center",
  },
  [`& .${rootClasses.buttonContainer}`]: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  [`& .${rootClasses.primaryButton}`]: {
    width: 280,
    padding: 15,
    fontSize: 16,
    borderRadius: 3,
    color: blumiraBlue,
    fontWeight: "normal",
    textTransform: "none",
    border: `1px solid ${blumiraBlue}`,
  },
}));

export const SignUpDialog = styled(Dialog)((theme) => ({
  [`& .${dialogClasses.logo}`]: {
    height: 50,
    marginBottom: 30,
  },
  [`& .${dialogClasses.dialogContent}`]: {
    width: 400,
    minHeigh: 600,
    display: "flex",
    textAlign: "center",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px !important",
  },
  [`& .${dialogClasses.dialogTitle}`]: {
    fontWeight: 400,
    paddingBottom: 10,
    fontSize: "1.5rem",
  },
  [`& .${dialogClasses.dialogDescText}`]: {
    fontSize: 13,
    fontWeight: 250,
  },
  [`& .${dialogClasses.auth0InspiredTextField}`]: {
    height: 50,
    width: "100%",
    borderRadius: 3,
    marginBottom: 10,
    padding: "0 15px",
    justifyContent: "center",
    backgroundColor: "white",
    "& input": {
      fontSize: 14,
    },
  },
  [`& .${dialogClasses.auth0ButtonContainer}`]: {
    width: "100%",
    marginTop: 50,
    display: "flex",
    flexDirection: "column",
  },
  [`& .${dialogClasses.auth0InspiredFilledButton}`]: {
    height: 50,
    width: "100%",
    color: "white",
    borderRadius: 3,
    marginBottom: 10,
    boxShadow: "none",
    textTransform: "none",
    backgroundColor: blumiraBlue,
    "&:hover": {
      backgroundColor: blumiraBlue,
    },
    "&.Mui-disabled": {
      color: "white",
      opacity: "60%",
    },
  },
  [`& .${dialogClasses.auth0InspiredTextButton}`]: {
    height: 50,
    width: "100%",
    borderRadius: 3,
    color: blumiraBlue,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  [`& .${dialogClasses.formHelperText}`]: {
    color: "#A4A6A7",
  },
}));
